<template>
  <ModalClose :modal="modal" asChild>
    <Button
      :variant="variant"
      :padding="padding"
      :size="size"
      :disabled="disabled"
    >
      <template #start>
        <slot name="start" />
      </template>
      <template #content>
        <slot>
          <span class="px-0.5 text-lg/normal md:text-base font-semibold">
            {{ label || t("components.buttons.cancel") }}
          </span>
        </slot>
      </template>
      <template #end>
        <slot name="end" />
      </template>
    </Button>
  </ModalClose>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { Button } from "@/Components/Button";
import { ModalClose } from "@/Components/Buttons";

defineProps({
  label: { type: String, required: false },
  variant: { type: String, default: "outline" },
  padding: { type: String, required: false },
  size: { type: String, required: false },
  modal: { type: String, required: false },
  disabled: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>
